import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class PaymentCancel {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <div class="fg-payment-result cancel">
                <div class="fg-payment-result__card">
                    <div class="fg-payment-result__icon">⚽</div>
                    <h1 class="fg-payment-result__title">Checkout Cancelled</h1>
                    <p class="fg-payment-result__text">No worries! No payment was taken and your items are still safe in your bag. Whenever you're ready, we're here.</p>
                    
                    <div class="fg-payment-result__actions">
                        <button class="fg-btn fg-btn--primary" id="btn-cancel-shop">Return to Shop</button>
                        <button class="fg-btn" id="btn-cancel-bag" style="border-color: #ddd; margin-top: 12px;">View My Bag</button>
                    </div>
                </div>
            </div>
        `;

        // Reuses styles from PaymentSuccess.js as they are injected globally
        el.innerHTML = sidebarPage({ title: '', main, wide: false, pageClass: 'fg-cancel-page' });
        this.attachEvents(el);
    }

    attachEvents(el) {
        el.querySelector('#btn-cancel-shop')?.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'shop' } }));
        });
        el.querySelector('#btn-cancel-bag')?.addEventListener('click', () => {
            // Open the cart drawer
            window.app.cartDrawer?.open();
            window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'shop' } }));
        });
    }
}